import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import CarbonCalculatorHub from './pages/CarbonCalculatorHub';
import CarbonTrackerNew from './pages/CarbonTrackerNew';
import CarbonTrackerYouth from './pages/CarbonTrackerYouth';
import EducationHub from './pages/EducationHub';
import Events from './pages/Events';
import Profile from './pages/Profile';
import AboutUs from './pages/AboutUs';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col overflow-x-hidden max-w-[100vw]">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/carbon-tracker" element={<CarbonCalculatorHub />} />
              <Route path="/carbon-tracker/nsf" element={<CarbonTrackerNew />} />
              <Route path="/carbon-tracker/youth" element={<CarbonTrackerYouth />} />
              <Route path="/education" element={<EducationHub />} />
              <Route path="/events" element={<Events />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/about" element={<AboutUs />} />

              <Route path="*" element={
                <div className="min-h-screen flex items-center justify-center px-4 overflow-x-hidden">
                  <div className="text-center max-w-full w-full box-border">
                    <h1 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 break-words">404 - Page Not Found</h1>
                    <p className="text-gray-600 mb-4 text-sm sm:text-base break-words">The page you're looking for doesn't exist.</p>
                    <p className="text-xs sm:text-sm text-gray-500 break-all mb-4">Current path: {window.location.pathname}</p>
                    <a href="/" className="mt-4 inline-block bg-primary-600 text-white px-6 py-2 rounded-lg hover:bg-primary-700 text-sm sm:text-base">
                      Go Home
                    </a>
                  </div>
                </div>
              } />
            </Routes>
          </main>
          <Footer />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 